<div *ngIf="modo==='normal'">


    <!-- <div class="container-carga" [ngStyle]="{'display': loader}">
        <div class="carga"></div>
    </div> -->

    <div class="seccion">
        <div class="nombre">
            <div class="label">
                <div class="ttile">
                    Historial
                </div>
                <div class="prepaf">
                    Estas son todas las compras que has realizado en nuestra plataforma online.
                </div>
            </div>
            <button class="btn-reload" (click)="reload()">Actualizar</button>

        </div>
    </div>
    <section class="histlist">
        <div class="container-carga" [ngStyle]="{'display': loader}">
            <div class="carga"></div>
        </div>
        <div class="noCompras" [ngStyle]="{'display': noCompras}">Usted no posee pedidos hechos con anterioridad.</div>
        <historial-generic-wiew *ngFor="let historia of historial" (onRepat)="recompra($event)"
            (onClick)="verDetalle($event)" [jistoria]="historia"></historial-generic-wiew>

    </section>

</div>